import ButtonIcon from "@visa/vds/button-icon";
import ButtonText from "@visa/vds/button-text";
import Icon from "@visa/vds/icon";
import React, { useRef, useState } from "react";
import {
  DragDropText,
  FileMetaData,
  FilePreviewContainer,
  FileUploadContainer,
  FormField,
  InputLabel,
  PreviewContainer,
  PreviewList,
} from "./_css/MCSDragDropFileUpload";

const KILO_BYTES_PER_BYTE = 1024;
const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 10 * 1024 * 1024;

const convertNestedObjectToArray = (nestedObj) =>
  Object.keys(nestedObj).map((key) => nestedObj[key]);

const convertBytesToKB = (bytes) => Math.round(bytes / KILO_BYTES_PER_BYTE);

const MCSDragDropFileUpload = ({
  label,
  updateFilesCb,
  maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  ...otherProps
}) => {
  const fileInputField = useRef(null);
  const [files, setFiles] = useState({});

  const handleUploadBtnClick = () => {
    fileInputField.current.click();
  };

  const addNewFiles = (newFiles) => {
    for (let file of newFiles) {
      if (file.size < maxFileSizeInBytes) {
        if (!otherProps.multiple) {
          return { file };
        }
        files[file.name] = file;
      }
    }
    return { ...files };
  };

  const callUpdateFilesCb = (files) => {
    const filesAsArray = convertNestedObjectToArray(files);
    updateFilesCb(filesAsArray);
  };

  const handleNewFileUpload = (e) => {
    const { files: newFiles } = e.target;
    if (newFiles.length) {
      let updatedFiles = addNewFiles(newFiles);
      setFiles(updatedFiles);
      callUpdateFilesCb(updatedFiles);
    }
  };

  const removeFile = (fileName) => {
    delete files[fileName];
    setFiles({ ...files });
    callUpdateFilesCb({ ...files });
  };

  return (
    <>
      <FileUploadContainer>
        <InputLabel>{label}</InputLabel>
        <DragDropText>Drag and drop the file or</DragDropText>
        <ButtonText ariaLabel="upload" onClick={handleUploadBtnClick}>
          <span> Browse {otherProps.multiple ? "files" : "a file"}</span>
          &nbsp;
          <Icon
            aria-hidden="false"
            name="cloud-upload"
            resolution="low"
            title="Upload"
          />
        </ButtonText>
        <FormField
          type="file"
          ref={fileInputField}
          onChange={handleNewFileUpload}
          title=""
          value=""
          {...otherProps}
        />
      </FileUploadContainer>
      <FilePreviewContainer>
        <span>To Upload</span>
        <PreviewList>
          {Object.keys(files).map((fileName, index) => {
            let file = files[fileName];

            return (
              <PreviewContainer key={fileName}>
                <div>
                  <FileMetaData>
                    <span>
                      {file.name.length > 100
                        ? file.name.substring(0, 100) + "..."
                        : file.name}
                    </span>
                    <aside>
                      <span>{convertBytesToKB(file.size)} kb</span>
                      <ButtonIcon
                        ariaLabel="close"
                        iconType="light-tiny"
                        onClick={() => removeFile(fileName)}
                      >
                        <Icon name="close" resolution="tiny" />
                      </ButtonIcon>
                    </aside>
                  </FileMetaData>
                </div>
              </PreviewContainer>
            );
          })}
        </PreviewList>
      </FilePreviewContainer>
    </>
  );
};

export default MCSDragDropFileUpload;
